import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CategoriesTemplate } from 'components/Templates'

const Categories: FC = () => {
  return (
    <Layout headline={'商品カテゴリー設定'} title={'商品カテゴリー設定'}>
      <CategoriesTemplate />
    </Layout>
  )
}

export default Categories
